const COLORS = ['#F8D373', '#EE7F23', '#F4EBDA', '#E3A92F']

export function Faces({ names, size }: { names: string[]; size?: number }) {
  return (
    <span className="faces" aria-label={`${names.length} people`}>
      {names.map((n, i) => (
        <span key={`${n}${i}`} style={{ background: COLORS[i % COLORS.length], ...(size ? { width: size, height: size, fontSize: size * 0.34 } : null) }}>
          {n}
        </span>
      ))}
    </span>
  )
}
